export default __webpack_public_path__ + "static/media/Savant's Sandals of the Crescent.417a6413.jpg";